import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import HomeHeader from './HomeHeader';
import Footer from './Footer';
import HomeFooter from './HomeFooter';

const MainLayout = () => {
  const location = useLocation();
  const isPublicPage = ['/', '/about-us', '/terms-of-use', '/privacy-policy', '/fundmewiz-app', '/travel', '/what-is-admin', '/what-is-participant', '/why-fundraise' ].includes(location.pathname);

  return (
    <div className="main-layout">
      {isPublicPage ? <HomeHeader /> : <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      {isPublicPage ? <HomeFooter /> : <Footer />}
    </div>
  );
};

export default MainLayout;